import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import LoginView from '@/views/LoginView.vue'
import TeacherView from '@/views/Teacher/TeacherView.vue'
import InstituteView from '@/views/Institute/InstituteView.vue'
import StudentPayment from '@/views/Institute/Student/StudentPayment.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },

  {
    path: '/login',
    name: 'login',
    component: LoginView
  },

  {
    path: '/teacherHome',
    name: 'teacherView',
    component: TeacherView
  },

  {
    path: '/instituteHome',
    name: 'instituteView',
    component: InstituteView
  },

  {
    path: '/studentPayment',
    name: 'StudentPayment',
    component: StudentPayment, // Your component for showing more details
    props: route => ({ studentItemId: Number(route.query.studentItemId) }), // Convert query parameter to number
  },

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
